import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'

const languageSelector = createSelector(
    entryDataSelector,
    (entryData): string => entryData.language || '',
)

export default languageSelector
